import { render, staticRenderFns } from "./Tutorials.vue?vue&type=template&id=40ef4674&scoped=true&"
import script from "./Tutorials.vue?vue&type=script&lang=js&"
export * from "./Tutorials.vue?vue&type=script&lang=js&"
import style0 from "./Tutorials.vue?vue&type=style&index=0&id=40ef4674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef4674",
  null
  
)

export default component.exports